<template>
  <div class="invoice-row px-i">
    <div class="invoice-info col-12">
      <div class="invoice-info-cell">
        <p class="invoice-info-cell-row-title invoice-info-cell-row-title-dark">
          Bill to
        </p>
        <p class="invoice-info-cell-row-title font-weight-normal">
          {{ invoice.customer_info.customer_display_name }}
        </p>
        <p v-if="showCustomerTaxInfo" class="invoice-info-cell-row-title font-weight-normal">
          {{ customerTaxInfo }}
        </p>
        <p v-if="showCustomerDetail('billing', 'address')" class="invoice-info-cell-row">
          {{ invoice.customer_info.customer_billing_address.address }}
        </p>
        <p v-if="showCustomerCityAndCountry('billing')" class="invoice-info-cell-row">
          {{ displayAddress(invoice.customer_info.customer_billing_address.zip_code, invoice.customer_info.customer_billing_address.city, invoice.customer_info.customer_billing_address.country) }}
        </p>
        <p v-if="showCustomerDetail('billing', 'phone_number')" class="invoice-info-cell-row">
          {{ invoice.customer_info.customer_billing_address.phone_number }}
        </p>
        <p v-if="showCustomerDetail('billing', 'attention')" class="invoice-info-cell-row">
          Attention: {{ invoice.customer_info.customer_billing_address.attention }}
        </p>
      </div>
    </div>
    <div v-if="showShippingAddress" class="invoice-info col-12">
      <div class="invoice-info-cell">
        <p class="invoice-info-cell-row-title invoice-info-cell-row-title-dark">
          Ship to
        </p>
        <p class="invoice-info-cell-row-title font-weight-normal">
          {{ invoice.customer_info.customer_display_name }}
        </p>
        <p v-if="showCustomerTaxInfo" class="invoice-info-cell-row-title font-weight-normal">
          {{ customerTaxInfo }}
        </p>
        <p v-if="showCustomerDetail('shipping', 'address')" class="invoice-info-cell-row">
          {{ invoice.customer_info.customer_shipping_address.address }}
        </p>
        <p v-if="showCustomerCityAndCountry('shipping')" class="invoice-info-cell-row">
          {{ displayAddress(invoice.customer_info.customer_shipping_address.zip_code, invoice.customer_info.customer_shipping_address.city, invoice.customer_info.customer_shipping_address.country) }}
        </p>
        <p v-if="showCustomerDetail('shipping', 'phone_number')" class="invoice-info-cell-row">
          {{ invoice.customer_info.customer_shipping_address.phone_number }}
        </p>
        <p v-if="showCustomerDetail('shipping', 'attention')" class="invoice-info-cell-row">
          Attention: {{ invoice.customer_info.customer_shipping_address.attention }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingShippingAddress",

  props: {
    invoice: { type: Object }
  },

  computed: {
    showCustomerTaxInfo () {
      return this.invoice.customer_info.customer_tax_type || this.invoice.customer_info.customer_tax_number;
    },

    customerTaxInfo () {
      let { customer_tax_type: taxType = "", customer_tax_number: taxNumber = "" } = this.invoice.customer_info;

      if (taxType === null) {
        taxType = "";
      }

      if (taxNumber === null) {
        taxNumber = "";
      }

      return `${taxType} ${taxNumber}`.trim();
    },

    showShippingAddress () {
      return ["address", "attention", "city", "country", "phone_number"].some(fieldDetail =>
        this.showCustomerDetail("shipping", fieldDetail)
      );
    }
  },

  methods: {
    displayAddress (zip, city, country) {
      let zipCity = `${zip} ${city}`.trim();

      if (country) {
        if (zipCity) {
          return `${zipCity}, ${country}`;
        } else {
          return country;
        }
      } else {
        return zipCity;
      }
    },

    showCustomerCityAndCountry (addressType) {
      return (this.invoice.customer_info[`customer_${addressType}_address`] &&
      (this.invoice.customer_info[`customer_${addressType}_address`]["city"] ||
      this.invoice.customer_info[`customer_${addressType}_address`]["country"]));
    },

    showCustomerDetail (addressType, field) {
      return (
        this.invoice.customer_info[`customer_${addressType}_address`] &&
        this.invoice.customer_info[`customer_${addressType}_address`][field]
      );
    }
  }
};
</script>
